import { attemptRequest } from 'redux-requests';
import { PENDING, SUCCESS, ERROR } from '../constants/status';

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const error = new Error(response.statusText);
  error.error = response;
  throw error;
};

const parseJSON = (response) => {
  let json;
  if (response.status === 204) {
    // no content
    return response.blob();
  }

  if (
    response.headers.get('Content-Type') === 'text/html; charset=utf-8' ||
    response.headers.get('Content-Type') === 'application/octet-stream' ||
    response.headers.get('Content-Type') === 'text/csv;charset=UTF-8' ||
    response.headers.get('Content-Type') === 'text/plain;charset=UTF-8'
  ) {
    return response.text();
  }

  try {
    json = response.json();
  } catch (e) {
    console.error('eeeeeeeeeeeeeeeeeeeee', e);
    throw new Error(e);
  }
  return json;
};
// var controller = new AbortController();
const createAction = (type, url, options) => {
  const { requestId, payload, ...rest } = options;
  const request = new Promise((resolve, reject) => {
    // controller.abort();
    // controller = new AbortController();
    fetch(url, rest) //{...rest, signal: controller?.signal})
      .then(checkStatus)
      .then(parseJSON)
      .then((res) => {
        resolve(res);
        return res;
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });

  const makeRequest = () => request;

  return (dispatch) => {
    attemptRequest(
      requestId || url,
      {
        begin: () => ({
          type: `${type}_${PENDING}`,
          payload
        }),
        success: (response) => ({
          type: `${type}_${SUCCESS}`,
          response,
          payload
        }),
        failure: (error) => {
          return {
            type: `${type}_${ERROR}`,
            error,
            payload
          };
        }
      },
      makeRequest,
      dispatch
    );
    return request;
  };
};

const fetchReq = (url, rest) => {
  return new Promise((resolve, reject) => {
    fetch(url, rest)
      .then(checkStatus)
      .then((res) => {
        resolve(res);
        return res;
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};

export default createAction;
export { fetchReq };
